import React,{Component} from 'react';

import {Clearfix,Button} from 'react-bootstrap';

import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import Icon from '../../../../components/Icon';
import PayoutsTable from './components/PayoutsTable';

class Form extends Component {
    constructor(props) {
        super(props);
        if(props.payout) {
            const {name, affid, countries} = props.payout;

            this.state = {
                name, affid, countries,
                defaultPayout: countries.default,
                selectedCountry:''
            };
        }
        else {
            this.state = {
                name: '',
                affid: '',
                selectedCountry: '',
                countries: {}
            };
        }


        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handlePayoutChange = this.handlePayoutChange.bind(this);
        this.handleAddBtn = this.handleAddBtn.bind(this);
        this.handlePayoutRemove = this.handlePayoutRemove.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        const { name, affid, countries, defaultPayout } = this.state;

        countries.default = defaultPayout;

        this.props.onSubmit({name,affid,countries});
    }

    handleFieldChange(event) {
        const {target} = event;
        const {value,name} = target;

        this.setState({
            [name]: value
        });
    }

    handlePayoutChange(event) {
        let {countries} =this.state;
        const {target} = event;
        const {name,value} = target;

        countries[name] = value;
        this.setState({countries});
    }

    handleAddBtn() {
        let {countries,selectedCountry} = this.state;
        if(selectedCountry) {
            countries[selectedCountry] = '';
            this.setState({countries});
        }

    }

    handlePayoutRemove(cc) {
        let {countries} = this.state;

        delete countries[cc];

        this.setState({countries});
    }

    render() {
        let {countries} = this.props;
        let selectedCountries = Object.keys(this.state.countries);

        let filteredCountries = countries.filter(cc => {
            return !( selectedCountries.includes(cc));
        });


        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit}>
                    <FieldGroup
                        name="name"
                        label="Name:"
                        onChange={this.handleFieldChange}
                        value={this.state.name}
                        required
                    />
                    <FieldGroup
                        name="affid"
                        label="Affid:"
                        onChange={this.handleFieldChange}
                        value={this.state.affid}
                        required
                    />
                    <FieldGroup
                        name="defaultPayout"
                        label="Default payout:"
                        onChange={this.handleFieldChange}
                        value={this.state.defaultPayout}
                    />
                    <SelectWrap
                        value={this.state.selectedCountry}
                        name="selectedCountry"
                        label="Country:"
                        values={filteredCountries}
                        onChange={this.handleFieldChange}
                    />
                    <Clearfix>
                        <Button className="pull-right m-b-15" bsStyle="success" onClick={this.handleAddBtn}><Icon name="plus"/> Add</Button>
                    </Clearfix>
                    <PayoutsTable payouts={this.state.countries} onChange={this.handlePayoutChange} onRemove={this.handlePayoutRemove}/>
                    <Clearfix>
                        <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                    </Clearfix>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/Payouts/components/Form/index.js